import { appendAppLog } from './appLog';

/**
 * Einstellungsnamen, die Stage nicht kennt — an **einer** Stelle formuliert und ins Dateilog
 * geschrieben (Bitte des Nutzers, 2026-10-08). Still übergangen wären sie ein Fehler, den
 * niemand sieht: der Verwalter setzt in Relay etwas, und auf dem Gerät geschieht nichts.
 *
 * ⚠️ **Nur Namen, nie Werte.** Bei einem unbekannten Namen weiss Stage nicht, ob er geheim ist;
 * das Dateilog verlässt mit jeder Protokollsicherung das Gerät.
 *
 * Die Einblendung dazu (`useToastStore.zeigeUnbekannte`) gibt es nur beim `SET_SETTINGS`: beim
 * QR-Code nennt die Vorschau die Namen schon, bevor der Prüfer übernimmt (Entscheidung des
 * Nutzers, 2026-10-08).
 */

export type Quelle = 'Relay-Befehl' | 'Relay-QR' | 'Classic-QR';

export function unbekannteZeile(quelle: Quelle, namen: string[], ausgang?: 'übernommen' | 'verworfen'): string {
  return (
    'Einstellungen unbekannt (' + quelle + (ausgang ? ', ' + ausgang : '') + '): ' + [...namen].sort().join(', ')
  );
}

/** Schreibt die Zeile, wenn es etwas zu melden gibt. Wirft nie. */
export function meldeUnbekannte(quelle: Quelle, namen: string[], ausgang?: 'übernommen' | 'verworfen'): void {
  if (namen.length === 0) return;
  try {
    void appendAppLog(unbekannteZeile(quelle, namen, ausgang), 'warn').catch(() => undefined);
  } catch {
    // Ein Protokoll, das selbst zum Fehler wird, darf die Übernahme nicht aufhalten.
  }
}
